import { render, staticRenderFns } from "./PatientStories.vue?vue&type=template&id=743cc16e"
import script from "./PatientStories.vue?vue&type=script&lang=js"
export * from "./PatientStories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports